// extracted by mini-css-extract-plugin
module.exports = {"rewards":"_32nsxSlapErBb6wuNaCYOe","rewardAmount":"_1bm5XIYkKvIbvMFC6w-u45"};